import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { configuration } from 'src/environments/environment';
import { ILockUsers } from 'src/app/models/ILockUsers';
import { SignOffLock } from 'src/app/models/SignOffLock';

@Injectable({
  providedIn: 'root'
})
export class LockService {

  constructor(private http: HttpClient) { }


  saveLockUsers(lockUsersInfo: ILockUsers): Observable<ILockUsers> {
    return this.http.post<ILockUsers>(`${configuration.apiUrl + 'Lock/Enable'}userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, lockUsersInfo, {
      // headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getLockUsers(userid: string, screenName: string, facilityId: any, encounterId: string):
    Observable<ILockUsers> {
    const LockUserDTO_PenRequest = {
      userid: userid,
      screenName: screenName,
      facilityId: facilityId,
      encounterId: encounterId
    }
    return this.http.post<ILockUsers>(`${configuration.clinicapiUrl + 'Encounter/User'}`, LockUserDTO_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  deleteLockUsersInfo(userId: string): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Lock/Release'}?userid=${encodeURIComponent(userId).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  deleteLockUser(userId: string, encounterId: string, screenName: string): Observable<string> {
    const DeleteLockUser_PenRequest = {
      userId: userId,
      screenName: screenName,
      encounterId: encounterId
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Lock/LockedUser'}`, DeleteLockUser_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSignOffLockById(userId: string, screenName: string): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Lock/SignOffLockById'}?userId=${encodeURIComponent(userId).toString()}&&screenName=${screenName}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSignOffLockByName(encounterId: string, screenName: string): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Lock/SignOffLockByName'}?encounterId=${encounterId}&&screenName=${screenName}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  SaveSignOffLock(signOffLock: SignOffLock): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Lock/EnableLock'}`, signOffLock, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getLockorUnlockCount(encounterId: string, screenName: string): Observable<string> {
    return this.http.get<string>(`${configuration.apiUrl + 'Lock/EnableLock'}?&&encounterId=${encounterId}&&screenName=${screenName}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });

  }
}
